import { render, staticRenderFns } from "./BookingSimulatorStudentIndex.vue?vue&type=template&id=4e7c73c2&scoped=true&"
import script from "./BookingSimulatorStudentIndex.vue?vue&type=script&lang=js&"
export * from "./BookingSimulatorStudentIndex.vue?vue&type=script&lang=js&"
import style0 from "./BookingSimulatorStudentIndex.vue?vue&type=style&index=0&id=4e7c73c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7c73c2",
  null
  
)

export default component.exports